var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 686,
    height: 16,
    viewBox: "0 0 686 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.559 6.2797C247.159 0.139109 455.055 0.38936 656.86 6.19123C695.299 7.29633 580.056 9.36718 541.575 9.82218C477.656 10.578 413.706 10.0996 349.774 9.82218C343.158 9.79347 336.609 8.98575 329.995 8.904C275.465 8.23008 220.91 8.31809 166.385 7.55568C135.813 7.12822 105.3 5.77008 74.7292 5.33471C53.3042 5.02959 31.8624 5.1446 10.4331 5.33471C7.60966 5.35976 -0.782348 5.96299 2.04125 5.97957C78.027 6.4259 154.046 5.48002 230.008 6.62447C262.258 7.11034 294.272 9.95383 326.492 10.8677C450.554 14.3867 563.654 16.4708 685.664 10.926",
    stroke: "#2350F1",
    strokeWidth: 1.57316
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath3);
export default __webpack_public_path__ + "static/media/Path-3.0e258dc0cb09be904bfa3946b9296833.svg";
export { ForwardRef as ReactComponent };